import axios from 'axios'
import qs from 'qs'
import fn from '../../utils/functions'
import FileSaver from 'file-saver'
import dayjs from 'dayjs';

// Normaliza fechas en profundidad para evitar que qs.stringify destruya objetos Dayjs
export function convertDates(obj) {
  if (obj == null) return obj;

  // Detecta Day.js correctamente
  if (dayjs.isDayjs(obj)) {
    return obj.toISOString();
  }

  // Detecta Date nativo
  if (obj instanceof Date) {
    return obj.toISOString();
  }

  // Arrays → recorrer
  if (Array.isArray(obj)) {
    return obj.map(item => convertDates(item));
  }

  // Objetos → recorrer recursivamente
  if (typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      newObj[key] = convertDates(obj[key]);
    }
    return newObj;
  }

  
  return obj;
}

function initSession () {
  const session = {
    // Documentos OCR
    ocrDocuments: {
      tableData: [],
      totalOcrDocuments: 0
    },
    queryOcrDocuments: {
      page: 0,
      size: 20,
      sort: 'creationDateTime,DESC',
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo()
    },
    listSelectedFiltersOcrDocuments: [],

    // Datos Select Filtros
    optionsFilterOcrDocumentsDocumentType: [],
    optionsFilterOcrDocumentsStatus: [],
    optionsFilterOcrDocumentsMailServer: []
  }
  return session
}

function initLocal () {
  const local = {
    // Columnas Tabla documentos OCR
    isShowLockedIcon: false,
    isShowDocumentNameOcrDocuments: true,
    isShowDocumentNumberOcrDocuments: true,
    isShowEmailToOcrDocuments: true,
    isShowStatusDocumentOcrDocuments: true,
    isShowProjectOcrDocuments: false,
    isShowSellerOcrDocuments: true,
    isShowMailServerOcrDocuments: true,
    isShowDocumentTypeOcrDocuments: false,
    isShowCreationDateTimeOcrDocuments: true,
    isShowOcrProcessDateOcrDocuments: false,
    isShowOcrBlockedDate: true,
    isShowOcrBlockedUser: true
  }
  return local
}

function setByUserLocalOcrDocument () {
  const local = {
    // Columnas Tabla documentos OCR
    isShowLockedIcon: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).ocrDocuments.isShowLockedIcon,
    isShowDocumentNameOcrDocuments: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).ocrDocuments.isShowDocumentNameOcrDocuments,
    isShowDocumentNumberOcrDocuments: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).ocrDocuments.isShowDocumentNumberOcrDocuments,
    isShowEmailToOcrDocuments: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).ocrDocuments.isShowEmailToOcrDocuments,
    isShowStatusDocumentOcrDocuments: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).ocrDocuments.isShowStatusDocumentOcrDocuments,
    isShowProjectOcrDocuments: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).ocrDocuments.isShowProjectOcrDocuments,
    isShowSellerOcrDocuments: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).ocrDocuments.isShowSellerOcrDocuments,
    isShowMailServerOcrDocuments: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).ocrDocuments.isShowMailServerOcrDocuments,
    isShowDocumentTypeOcrDocuments: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).ocrDocuments.isShowDocumentTypeOcrDocuments,
    isShowCreationDateTimeOcrDocuments: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).ocrDocuments.isShowCreationDateTimeOcrDocuments,
    isShowOcrProcessDateOcrDocuments: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).ocrDocuments.isShowOcrProcessDateOcrDocuments,
    isShowOcrBlockedDate: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).ocrDocuments.isShowOcrBlockedDate,
    isShowOcrBlockedUser: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).ocrDocuments.isShowOcrBlockedUser
  }
  return local
}

// state
const state = () => ({
  userConfigLocalStorage: '',
  local: {
    // Columnas Tabla Documentos OCR
    isShowLockedIcon: false,
    isShowDocumentNameOcrDocuments: true,
    isShowDocumentNumberOcrDocuments: true,
    isShowEmailToOcrDocuments: true,
    isShowStatusDocumentOcrDocuments: true,
    isShowProjectOcrDocuments: false,
    isShowSellerOcrDocuments: true,
    isShowMailServerOcrDocuments: true,
    isShowDocumentTypeOcrDocuments: false,
    isShowCreationDateTimeOcrDocuments: true,
    isShowOcrProcessDateOcrDocuments: false,
    isShowOcrBlockedDate: true,
    isShowOcrBlockedUser: true
  },
  session: initSession()
})

// getters
const getters = {
  // Datos Tablas Documentos OCR
  ocrDocuments: state => {
    return state.session.ocrDocuments;
  },
  queryOcrDocuments: state => {
    return state.session.queryOcrDocuments;
  },
  listSelectedFiltersOcrDocuments: state => {
    return state.session.listSelectedFiltersOcrDocuments;
  },

  // Datos Select Filtros
  optionsFilterOcrDocumentsDocumentType: state => {
    return state.session.optionsFilterOcrDocumentsDocumentType
  },
  optionsFilterOcrDocumentsStatus: state => {
    return state.session.optionsFilterOcrDocumentsStatus
  },
  optionsFilterOcrDocumentsMailServer: state => {
    return state.session.optionsFilterOcrDocumentsMailServer
  },

  // Columnas Tabla documentos OCR
  isShowLockedIcon: state => {
    return state.local.isShowLockedIcon
  },
  isShowDocumentNameOcrDocuments: state => {
    return state.local.isShowDocumentNameOcrDocuments
  },
  isShowDocumentNumberOcrDocuments: state => {
    return state.local.isShowDocumentNumberOcrDocuments
  },
  isShowEmailToOcrDocuments: state => {
    return state.local.isShowEmailToOcrDocuments
  },
  isShowStatusDocumentOcrDocuments: state => {
    return state.local.isShowStatusDocumentOcrDocuments
  },
  isShowProjectOcrDocuments: state => {
    return state.local.isShowProjectOcrDocuments
  },
  isShowSellerOcrDocuments: state => {
    return state.local.isShowSellerOcrDocuments
  },
  isShowMailServerOcrDocuments: state => {
    return state.local.isShowMailServerOcrDocuments
  },
  isShowDocumentTypeOcrDocuments: state => {
    return state.local.isShowDocumentTypeOcrDocuments
  },
  isShowCreationDateTimeOcrDocuments: state => {
    return state.local.isShowCreationDateTimeOcrDocuments
  },
  isShowOcrProcessDateOcrDocuments: state => {
    return state.local.isShowOcrProcessDateOcrDocuments
  },
  isShowOcrBlockedDate: state => {
    return state.local.isShowOcrBlockedDate
  },
  isShowOcrBlockedUser: state => {
    return state.local.isShowOcrBlockedUser
  }
}

// actions
const actions = {
  // Crear key Usuario
  setUserNameOcr ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalOcrDocument()
    }
  },
  isNewVersionOcrDocumentsLocalState ({ state }, localStorage) {
    return fn.isNewVersion(state, localStorage.ocrDocuments)
  },

  /* DOCUMENTOS OCR */
  /**
   * Servicio para traer los documentos OCR.
   * Se utiliza también para ordenar la tabla, la paginación,
   * el tamaño de la tabla y los filtros.
   */
  async getOcrDocuments ({
    commit, rootState
  }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        // baseURL: 'http://localhost:8084/edocs-rest/rest-api/v1',
        url: '/ocr',
        params: data.query,
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })

      commit('OCR_DOCUMENTS_STATE', {
        tableData: response.data.content,
        totalOcrDocuments: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // GET detalle de un documento OCR
  async getOcrDocument ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        // baseURL: 'http://localhost:8084/edocs-rest/rest-api/v1',
        url: '/ocr/' + params.documentId + '/' + params.projectName + '/detail',
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // GET/POST bloqueo/desbloqueo permanente de un documento OCR
  async permanentLockUnlock ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/ocr/' + params.documentId + '/' + params.projectName + '/permanentlockunlock',
        params: {
          lock: params.lock
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // GET adjuntos de un documento OCR
  async getOcrDocumentAttachment ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/ocr/' + params.documentId + '/attachments'
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // GET líneas de un documento OCR
  async getOcrDocumentLines ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/ocr/' + params.documentId + '/lines'
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // GET impuestos/tasas de un documento OCR
  async getOcrDocumentTaxes ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/ocr/' + params.documentId + '/taxes'
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para descargar los adjuntos de un documento OCR.
     * @param {*} params
     */
  async downloadOcrDocumentAttachment ({
    commit,
    rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/ocr/' + params.attachmentId,
        params: {
          searchType: params.searchType
        },
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })

      const filename = fn.extractFilename(response.headers['content-disposition'], 'adjunto-factura')
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /*
  * Servicio para llenar select de estados de documentos OCR
  */
  async loadFilterStatusDocumentByType ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/ocr/statusDocument/' + data.type,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      commit('OPTIONS_FILTER_OCR_DOCUMENTS_STATUS', response.data);
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data;
    } catch (error) {
      console.log('loadFilterStatusDocumentByType: ', error)
      throw error.response
    }
  },

  // Servicio para llenar Select Filtro tipo de Documento.
  async loadFilterOcrDocumentType({ commit, rootState }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/documenttype',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      commit('OPTIONS_FILTER_OCR_DOCUMENTS_DOCUMENT_TYPE', response.data);
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data;
    } catch (error) {
      console.error('Error loadFilterOcrDocumentType:', error);
    }
  },

  // Servicio para llenar Select Filtro de servidores de correo.
  async loadFilterOcrDocumentMailServer({
    commit, rootState
  }, data) {
    console.log('Query Parameters:', data.query);
    try {
      const response = await axios({
        method: 'GET',
        url: '/mailServer/custom',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query,
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })
      commit('OPTIONS_FILTER_OCR_DOCUMENTS_MAIL_SERVER', response.data);
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data;
    } catch (error) {
      console.error('Error loadFilterOcrDocumentMailServer:', error);
    }
  },

  /**
   * Servicio para aprobar/rechazar un documento OCR tras su validación manual.
   */
  async sendOcrDocument ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/ocr/sendOcrDocument/' + data.action,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /*
  * Servicio para exportar todos los ocrDocuments bajo parámetros en formato CSV
  */
  async handleDownloadAllCsvOcrDocuments ({
    commit, rootState
  }, params) {
    try {
      console.log('handleDownloadAllCsvOcrDocuments:: ', params)
      params.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
        rootState.session.urlIn !== 'b2b') {
        params.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/ocr/csv',
        params: params,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        headers: { 'Accept-Language': params.activeLang },
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })
      console.log('RESPONSE handleDownloadAllCsvOcrDocuments:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })

      const filename = fn.extractFilename(response.headers['content-disposition'], 'all-csv-ocr-documents.pdf')
      FileSaver.saveAs(blob, filename)
      
      return (filename)
    } catch (error) {
      console.log('handleDownloadAllCsvUsers: ', error.response)
      throw error.response
    }
  },

  // Datos Tabla Documentos OCR
  queryOcrDocumentsState: ({
    commit
  }, payload) => {
    commit('QUERY_OCR_DOCUMENTS_STATE', payload)
  },
  listSelectedFiltersOcrDocumentsState: ({
    commit
  }, payload) => {
    commit('LIST_SELECTED_FILTERS_OCR_DOCUMENTS_STATE', payload)
  },
  // Datos Select Filtros
  optionsFilterOcrDocumentsDocumentTypeState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_OCR_DOCUMENTS_DOCUMENT_TYPE', payload)
  },
  optionsFilterOcrDocumentsMailServerState: ({  
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_OCR_DOCUMENTS_MAIL_SERVER', payload)
  },
  optionsFilterOcrDocumentsStatusState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_OCR_DOCUMENTS_STATUS', payload)
  },

  // Tabla documentos OCR
  isShowLockedIconAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_LOCKED_ICON', payload)
  },
  isShowDocumentNameOcrDocumentsAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_DOCUMENT_NAME_OCR_DOCUMENTS', payload)
  },
  isShowDocumentNumberOcrDocumentsAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_DOCUMENT_NUMBER_OCR_DOCUMENTS', payload)
  },
  isShowEmailToOcrDocumentsAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_EMAIL_TO_OCR_DOCUMENTS', payload)
  },
  isShowStatusDocumentOcrDocumentsAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_STATUS_DOCUMENT_OCR_DOCUMENTS', payload)
  },
  isShowProjectOcrDocumentsAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_PROJECT_OCR_DOCUMENTS', payload)
  },
  isShowSellerOcrDocumentsAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_SELLER_OCR_DOCUMENTS', payload)
  },
  isShowMailServerOcrDocumentsAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_MAIL_SERVER_OCR_DOCUMENTS', payload)
  },
  isShowDocumentTypeOcrDocumentsAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_DOCUMENT_TYPE_OCR_DOCUMENTS', payload)
  },
  isShowCreationDateTimeOcrDocumentsAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CREATION_DATE_TIME_OCR_DOCUMENTS', payload)
  },
  isShowOcrProcessDateOcrDocumentsAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_OCR_PROCESS_DATE_OCR_DOCUMENTS', payload)
  },
  isShowOcrBlockedDateAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_OCR_BLOCKED_DATE', payload)
  },
  isShowOcrBlockedUserAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_OCR_BLOCKED_USER', payload)
  }
}

// mutations
const mutations = {
  resetSessionOcrDocuments (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  // Funcion para definir el filtro rápido de fechas cuando se es superadmin
  ocrDatesSuperAdmin (state) {
    state.session.queryInvoiceDrafts.creationDateTimeFrom = fn.initDateFrom(1)
  },
  // Documentos OCR
  'OCR_DOCUMENTS_STATE' (state, payload) {
    state.session.ocrDocuments = payload
  },
  'QUERY_OCR_DOCUMENTS_STATE' (state, payload) {
    state.session.queryOcrDocuments = payload
  },
  'LIST_SELECTED_FILTERS_OCR_DOCUMENTS_STATE' (state, payload) {
    state.session.listSelectedFiltersOcrDocuments = payload
  },
  // Datos Select Filtros
  'OPTIONS_FILTER_OCR_DOCUMENTS_DOCUMENT_TYPE' (state, payload) {
    state.session.optionsFilterOcrDocumentsDocumentType = payload
  },
  'OPTIONS_FILTER_OCR_DOCUMENTS_STATUS' (state, payload) {
    state.session.optionsFilterOcrDocumentsStatus = payload
  },
  'OPTIONS_FILTER_OCR_DOCUMENTS_MAIL_SERVER' (state, payload) {
    state.session.optionsFilterOcrDocumentsMailServer = payload
  },
  // Columnas Tabla Documentos OCR
  'IS_SHOW_LOCKED_ICON' (state, payload) {
    state.local.isShowLockedIcon = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.ocrDocuments.isShowLockedIcon = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DOCUMENT_NAME_OCR_DOCUMENTS' (state, payload) {
    state.local.isShowDocumentNameOcrDocuments = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.ocrDocuments.isShowDocumentNameOcrDocuments = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DOCUMENT_NUMBER_OCR_DOCUMENTS' (state, payload) {
    state.local.isShowDocumentNumberOcrDocuments = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.ocrDocuments.isShowDocumentNumberOcrDocuments = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_EMAIL_TO_OCR_DOCUMENTS' (state, payload) {
    state.local.isShowEmailToOcrDocuments = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.ocrDocuments.isShowEmailToOcrDocuments = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_DOCUMENT_OCR_DOCUMENTS' (state, payload) {
    state.local.isShowStatusDocumentOcrDocuments = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.ocrDocuments.isShowStatusDocumentOcrDocuments = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PROJECT_OCR_DOCUMENTS' (state, payload) {
    if (!state.local) state.local = {}
    state.local.isShowProjectOcrDocuments = !!payload
    const key = state.userConfigLocalStorage
    let storeuser
    try {
      storeuser = JSON.parse(localStorage.getItem(key)) || {}
    } catch {
      storeuser = {}
    }
    storeuser.ocrDocument = storeuser.ocrDocument || {}
    storeuser.ocrDocument.isShowProjectOcrDocuments = !!payload
    localStorage.setItem(key, JSON.stringify(storeuser))
  },
  'IS_SHOW_SELLER_OCR_DOCUMENTS' (state, payload) {
    state.local.isShowSellerOcrDocuments = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.ocrDocuments.isShowSellerOcrDocuments = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_MAIL_SERVER_OCR_DOCUMENTS' (state, payload) {
    state.local.isShowMailServerOcrDocuments = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.ocrDocuments.isShowMailServerOcrDocuments = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_DOCUMENT_TYPE_OCR_DOCUMENTS' (state, payload) {
    state.local.isShowDocumentTypeOcrDocuments = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.ocrDocuments.isShowDocumentTypeOcrDocuments = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CREATION_DATE_TIME_OCR_DOCUMENTS' (state, payload) {
    state.local.isShowCreationDateTimeOcrDocuments = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.ocrDocuments.isShowCreationDateTimeOcrDocuments = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_OCR_PROCESS_DATE_OCR_DOCUMENTS' (state, payload) {
    state.local.isShowOcrProcessDateOcrDocuments = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.ocrDocuments.isShowOcrProcessDateOcrDocuments = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_OCR_BLOCKED_DATE' (state, payload) {
    state.local.isShowOcrBlockedDate = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.ocrDocuments.isShowOcrBlockedDate = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_OCR_BLOCKED_USER' (state, payload) {
    state.local.isShowOcrBlockedUser = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.ocrDocuments.isShowOcrBlockedUser = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
